import apiClient from 'api';
import _ from 'lodash';
import { RESOURCE_TYPES } from 'utils/appConstants';
import { mapControlResponses } from 'reducers/control/utils';
import { fetchAllFromMonitorServer } from 'api/common';
import { formatControlTypes } from 'utils/format';
import { fetchTopoNodeDefaultControl } from 'api/toponode';
import { fetchIndeNodeDefaultControl } from 'api/indenode';

const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;

export const fetchAllControls = async (queryParams = {}) => {
  const controls = await fetchAllFromMonitorServer(
    'control',
    ['devId', 'nodeId', 'start', 'limit', 'deleted'],
    queryParams
  );
  return controls.map(control => formatControlTypes(control));
};

export const fetchAllResponses = async (queryParams = {}) => {
  return await fetchAllFromMonitorServer(
    'response',
    ['devId', 'start', 'limit', 'status'],
    queryParams
  );
};

export const fetchAllControlsAndResponses = async (queryParams = {}) => {
  const controls = await fetchAllControls(queryParams);
  const responses = await fetchAllResponses();
  return mapControlResponses(controls, responses);
};

export const fetchNodeControls = async (id, type) => {
  let defaultControl;
  if (type === RESOURCE_TYPES.TOPONODE) {
    defaultControl = await fetchTopoNodeDefaultControl(id);
  } else if (type === RESOURCE_TYPES.INDENODE) {
    defaultControl = await fetchIndeNodeDefaultControl(id);
  }

  let scheduledControls = await fetchAllControls({ nodeId: id });
  const controlResponses = await fetchAllResponses();
  scheduledControls = mapControlResponses(scheduledControls, controlResponses);

  return {
    defaultControl,
    scheduledControls
  };
};

export const create = async control => {
  const filteredPayload = _.omitBy(
    control,
    value => value === null || value === '' || _.isNaN(value)
  );
  return await apiClient.post(northgateApiBaseUrl, `/control`, filteredPayload);
};

export const cancel = async (controlId, cancelValues) => {
  return await apiClient.put(
    northgateApiBaseUrl,
    `/control/${controlId}`,
    cancelValues
  );
};
